import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";

loadFonts();

async function initApp() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: process.env.VUE_APP_AWS_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID,
        signUpVerificationMethod: "code",
        loginWith: {
          email: true,
        },
      },
    },

    API: {
      GraphQL: {
        endpoint: process.env.VUE_APP_AWS_GRAPHQL_ENDPOINT,
        region: process.env.VUE_APP_AWS_REGION,
        defaultAuthMode: "userPool",
      },
    },
  });
}
window.addEventListener("beforeunload", () => {
  localStorage.setItem("lastClosedAt", Date.now().toString());
});

router.beforeEach((to, from, next) => {
  const closedAt = parseInt(localStorage.getItem("lastClosedAt"), 10);
  const now = Date.now();

  const isLoggedIn = store.getters.isAuthenticated;

  if (isLoggedIn && closedAt && now - closedAt > 10000) {
    console.log("Detected REAL tab close → Reset Vuex");

    store.dispatch("clearMotoristAndCarDetails");
    localStorage.removeItem("lastClosedAt");
  }

  next();
});

initApp().then(() => {
  createApp(App).use(router).use(store).use(vuetify).mount("#app");
});
